/* eslint-disable */
const getters = {
  getFilterGroup(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
